import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import Orders from "../Orders/Orders";
import { isWhitelisted } from "../../constant/whitelisted-user";
import { auth } from "../../config/firebase";
import Heading from "../../common/Heading";
import Seo from "../../components/Seo";

import { routeMeta } from "../../seo/staticRoutes";
/**
 * Admin view of every order.
 *
 * The previous version computed the whitelist check inside a useEffect and threw
 * the result away, while the render only checked "is anyone signed in" — so any
 * customer who signed in could read the full order book. Firebase also restores
 * the session asynchronously, so `auth.currentUser` is null on first render;
 * that's why this waits for onAuthStateChanged instead of reading it directly.
 *
 * This gates the UI only. Firestore security rules on the `orders` collection
 * remain the actual access control.
 */
export default function AllOrders() {
  const [status, setStatus] = useState("checking"); // checking | allowed | denied

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setStatus(isWhitelisted(user?.email) ? "allowed" : "denied");
    });
    return () => unsubscribe();
  }, []);

  if (status === "checking") {
    return (
      <>
        <Seo {...routeMeta("/dashboard")} />
        <Heading title="Home" subtitle="Dashboard" />
        <div className="container py-5 text-center">
          <p className="m-0">Checking your access…</p>
        </div>
      </>
    );
  }

  if (status === "denied") {
    return (
      <>
        <Heading title="Home" subtitle="Dashboard" />
        <div className="container py-5 text-center">
          <h3>This page is for NT Sticks staff</h3>
          <p className="text-muted">
            You don't have access to the order dashboard. If you're looking for your
            own orders, they're on the My Orders page.
          </p>
          <Link to="/myorders" className="btn-professional-primary">
            Go to My Orders
          </Link>
        </div>
      </>
    );
  }

  return <Orders allOrders />;
}
